import { Link } from "react-router-dom";

export default function Breadcrumb({ items = [] }) {
  // items: [{ label, to }]  — last item is current
  return (
    <nav className="breadcrumb" data-testid="breadcrumb" aria-label="breadcrumb">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            {last ? (
              <span className="current">{it.label}</span>
            ) : (
              <Link to={it.to}>{it.label}</Link>
            )}
            {!last && <span className="sep">/</span>}
          </span>
        );
      })}
    </nav>
  );
}
